export default{
    insuranceTitle: 'عنوان بیمه',
    kp: 'ضریب حرفه‌ای',
    ka: 'ضریب بیهوشی',
    kt: 'ضریب  فنی',
    kOther: ' سایر (مبلغ خدمت)',
}